module.exports = __webpack_public_path__ + "static/media/Ilogo.f71bc5f6.svg";